import { useState, useRef } from "react";
import { API_URL, isFieldError, getValFromLS } from "../../helpers";
import Input from "../../components/Input";
import InputDate from "../../components/InputDate";
import Select from "../../components/Select";
import Checkbox from "../../components/Checkbox";
import Msg from "../../components/Msg";
import Submit from "../../components/Submit";

const Form = ({ registrationId, campaignYr, success, email }) => {
	const [errors, setErrors] = useState([]);
	const [names, setNames] = useState({});
	const [msg, setMsg] = useState({});

	const formElement = useRef(null);

	const handleUpdate = (name, value) => {
		setNames((names) => ({ ...names, [name]: value ? value : "" }));
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setErrors([]);
		setMsg({
			type: "working",
			text: "",
		});

		const url = new URL(`${API_URL}/admin/payment`);
		let data = new FormData();
		Object.entries(names).forEach(([key, value]) => {
			data.append(key, value);
		});
		data.append("registrationId", registrationId);
		data.append("campaignYr", campaignYr);
		data.append("token", getValFromLS("vtoUserToken"));

		try {
			const response = await fetch(url, {
				method: "POST",
				body: data,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				setMsg({});
				success(json.text);
			} else {
				setErrors(json.fields);
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	return (
		<form
			ref={formElement}
			method="post"
			action="/"
			onSubmit={(e) => handleSubmit(e)}
			className="well"
			style={{ marginTop: "25px" }}
		>
			<h4
				style={{
					marginTop: "0",
					lineHeight: "22px",
					marginBottom: "15px",
					fontSize: "1.1rem",
				}}
			>
				Payment Details
			</h4>

			<div className="form-group">
				<Select
					name="method"
					label="Payment Method"
					reqd={true}
					value={""}
					options={[
						{ id: "", name: "--", val: "" },
						{
							id: "ach",
							name: "ACH",
							val: "ACH",
						},
						{
							id: "check",
							name: "Check",
							val: "Check",
						},
						{
							id: "credit",
							name: "Credit Card",
							val: "Credit Card",
						},
						{
							id: "inkind",
							name: "In Kind",
							val: "In Kind",
						},
					]}
					update={handleUpdate}
					error={isFieldError(errors, "method")}
				/>

				<div className="empty" />
			</div>

			<div className="form-group">
				<Input
					name="description"
					label="Optional Description (ACH #, check #, etc.)"
					reqd={false}
					value={""}
					autocomplete="off"
					update={handleUpdate}
					errors={errors}
				/>
				<Input
					name="received"
					label="Received By"
					reqd={true}
					value={""}
					autocomplete="off"
					update={handleUpdate}
					errors={errors}
				/>
			</div>

			<div className="form-group">
				<Input
					name="amount"
					label="Amount"
					reqd={true}
					value={""}
					autocomplete="off"
					update={handleUpdate}
					errors={errors}
					addonIcon="fa-dollar-sign"
				/>

				<InputDate
					name="date"
					label="Date"
					reqd={true}
					value={""}
					autocomplete="off"
					update={handleUpdate}
					errors={errors}
				/>
			</div>

			<div className="form-group one">
				<Input
					name="comments"
					label="Admin Comments (not displayed on invoice)"
					reqd={false}
					value={""}
					autocomplete="off"
					update={handleUpdate}
					errors={errors}
				/>
			</div>

			<div className="form-group checkbox" style={{ marginTop: "10px" }}>
				<Checkbox
					name="sendEmail"
					label={`Check to send a payment confirmation email to ${email}`}
					checked={false}
					click={handleUpdate}
				/>
			</div>

			<div className="msg-submit" style={{ marginTop: "30px" }}>
				{msg.type && <Msg data={msg} />}

				<div
					className={
						msg.type === "working" || msg.type === "success"
							? "hidden"
							: "submit-container"
					}
				>
					<Submit submit="Submit Payment" />
				</div>
			</div>
		</form>
	);
};

export default Form;
